export default "__VITE_ASSET__rMrQSijp__"